import React from 'react';
import {useSelector} from "react-redux";
import {ApplicationState} from "../../../store";
import {TimelineState} from "../../../store/timeline/types";
import './style.css';


const TimelineTitleComponent: React.FC = () => {
    const { title } = useSelector<ApplicationState, TimelineState>(state => state.timeline);

    return <div className='timeline-title'>
        <div>{ title } <span>&#8596;</span></div>
    </div>
};


export default TimelineTitleComponent